var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVaProgress = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08008 19.5081L10 11.5882V14.4182L3.49008 20.9181C3.15008 20.8281 2.84008 20.6481 2.59008 20.4081C2.35008 20.1581 2.17008 19.8481 2.08008 19.5081Z",
    fill: "#E99921"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.88003L2 11.88V14.71L10 6.71003V3.88003Z",
    fill: "#E99921"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 3C2.9 3 2 3.9 2 5V7L6 3H4Z",
    fill: "#E99921"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29004 21L10 21V19.2901L8.29004 21Z",
    fill: "#E99921"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1H12V23H10V1Z",
    fill: "#E99921"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7V5L18 5V3H20V5L22 5V7H20V17H22V19H20V21H18V19H14V17H18V7L14 7Z",
    fill: "#E99921"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVaProgress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vaProgress.982ed46a4d1718feb06fb5c889d9c37c.svg";